<template>
    <div>
        <BaseConfig />
    </div>
</template>

<script>
import BaseConfig from "./baseConfigView.vue";
export default {
    components: {
        BaseConfig,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
